module.exports = __webpack_public_path__ + "expiry.edad9385.svg";